import { Dispatch, SetStateAction, useCallback } from 'react'
import { ChannelEventsState, useChannelEvents } from 'hooks/useOverlaySubscription'
import { EventDetail, TriviaSummary } from 'types/api'

export const upsertTriviaRow = (prev: EventDetail | null, incoming: TriviaSummary): EventDetail | null => {
  if (prev == null) return prev
  const idx = prev.trivias.findIndex((t) => t.triviaId === incoming.triviaId)
  if (idx === -1) return { ...prev, trivias: [...prev.trivias, incoming] }
  if (prev.trivias[idx].version > incoming.version) return prev
  const next = prev.trivias.slice()
  next[idx] = incoming
  return { ...prev, trivias: next }
}

export const useTriviaAdminFold = (
  slug: string,
  socketToken: string | null,
  setEvent: Dispatch<SetStateAction<EventDetail | null>>
): ChannelEventsState => {
  const onUpdate = useCallback((incoming: TriviaSummary) => {
    setEvent((prev) => upsertTriviaRow(prev, incoming))
  }, [setEvent])
  const onDelete = useCallback((triviaId: string) => {
    setEvent((prev) => prev == null
      ? prev
      : { ...prev, trivias: prev.trivias.filter((t) => t.triviaId !== triviaId) })
  }, [setEvent])
  return useChannelEvents<TriviaSummary>(`${slug}:trivia:admin`, socketToken, { onUpdate, onDelete })
}
